import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-xl overflow-hidden bg-white border border-neutral-100 hover:border-primary-200 transition-all duration-300"
      data-product-shop=""
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={video.cover}
          alt={`${video.title} - 白云视频免费在线观看`}
          title={`${video.title} - 白云视频`}
          className="w-full h-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
          <span className="px-4 py-2 bg-primary-500 text-white rounded-full text-sm font-medium whitespace-nowrap flex items-center gap-1">
            <i className="ri-play-fill text-sm"></i>
            立即播放
          </span>
        </div>
        {video.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
            热播
          </span>
        )}
        {video.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-secondary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
            最新
          </span>
        )}
        <div className="absolute bottom-2 right-2 px-1.5 py-0.5 bg-black/70 text-white text-xs font-semibold rounded">
          {video.score}
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 flex items-center gap-2">
          <span>{video.year}</span>
          <span>·</span>
          <span className="truncate">{video.episodeInfo}</span>
        </p>
      </div>
    </Link>
  );
}